import React from 'react';
import styles from './styles.module.scss';
import { BaseEditModal } from 'components';
import { DocumentTextIcon, WarningIcon } from 'assets';

interface UnansweredSection {
  id: string;
  label: string;
  count: number;
}

interface SubmitAssessmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onReview?: () => void;
  isLoading?: boolean;
  unansweredQuestionsCount?: number;
  unansweredSections?: UnansweredSection[];
}

export const SubmitAssessmentModal: React.FC<SubmitAssessmentModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  onReview,
  isLoading,
  unansweredQuestionsCount = 0,
  unansweredSections = [],
}) => {
  const hasUnanswered = unansweredQuestionsCount > 0;

  return (
    <BaseEditModal
      isOpen={isOpen}
      onClose={onClose}
      onSwitch={hasUnanswered && onReview ? onReview : onClose}
      title="Submit Assessment"
      onSubmit={onSubmit}
      isSubmitting={isLoading}
      cancelButtonText={hasUnanswered ? "Review Questions" : "Return back"}
      saveButtonText={hasUnanswered ? "Submit Anyway" : "Confirm and Submit"}
      footerClassName={styles.footer}
      contentClassName={styles.modalContainer}
      cvType={true}
    >
      <div className={styles.modalContent}>
        <div className={`${styles.icon} ${hasUnanswered ? styles.warningIcon : ''}`}>
          {hasUnanswered ? <WarningIcon /> : <DocumentTextIcon />}
        </div>
        <h4 className={styles.header}>
          Are you sure?
        </h4>
        {hasUnanswered ? (
          <p className={styles.text}>
            You have <b>{unansweredQuestionsCount} unanswered question{unansweredQuestionsCount !== 1 ? 's' : ''}</b>. After you submit, you can't edit this assessment. Do you want to submit anyway?
          </p>
        ) : (
          <p className={styles.text}>
            After you submit, you can't edit your assessment. Do you want to submit this assessment?
          </p>
        )}

        {hasUnanswered && unansweredSections.length > 0 && (
          <div className={styles.sectionsBox}>
            <p className={styles.sectionsTitle}>Unanswered Questions</p>
            <p className={styles.sectionsList}>
              {unansweredSections.map((section, index) => (
                <React.Fragment key={section.id}>
                  {index > 0 && <span className={styles.sectionsDot}>•</span>}
                  {section.label} <b>({section.count})</b>
                </React.Fragment>
              ))}
            </p>
          </div>
        )}
      </div>
    </BaseEditModal>
  );
};
